// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BackgroundVideo_wrapper__NF4PO","noRoundedCorners":"BackgroundVideo_noRoundedCorners__nMoS7","video":"BackgroundVideo_video__OHyb6"};